GatiServerGame = function () {
  // this.loadLanguageFiles = undefined;
  var base = new GatiServer();
  GatiServer.call(this, base);

  this.gambleForces = [];
  this.collectForce = undefined;

  this._coinValue = 10; // usual YG coin stuff
  this.inFS = false;
  this.fsIndex = 0;
  this.fsWinnings = 0;
  this.numFsRemaining = 0;
  this.fsCount = 0;

  this.freeSpinsCostMultiplier = 100;

  this.addGameConfigToQueueBase = this.addGameConfigToQueue;
  this.addGameConfigToQueue = this.addGameConfigToQueueDerived;

  this.addRecoveryToQueueBase = this.addRecoveryToQueue;
  this.addRecoveryToQueue = this.addRecoveryToQueueDerived;
  this.restorePreviousWagersBase = this.restorePreviousWagers;
  this.restorePreviousWagers = this.restorePreviousWagersDerived;

  this.startGameBase = this.startGame;
  this.startGame = this.startGameDerived;
  this._inEncore = false;
  this._inBuyABonus = false;
  this._rtp = 0;
  this._baseGameWinnings = 0;
  this._totalWinnings = 0;
  this._finalBaseWinnings = 0;
  this._finalFsWinnings = 0;
  this._localRngSeed = -1;

  this._baseOutcome = {
    spins: [],
  };
};

GatiServerGame.prototype = Object.create(GatiServer.prototype);

GatiServerGame.prototype.initServer = function (cb) {
  this.init(
    function () {
      cb();
    },
    function () {},
    "ReflexGaming",
    "LEFT_TOP",
    [],
    "TOP_LEFT",
  );
};

GatiServerGame.prototype.getSupplierForceName = function () {
  return "gati_" + this._rtp * 1000;
};

GatiServerGame.prototype.updateCurrentStake = function (newStake) {
  if (this._stake != newStake) {
    let isStakeLower = newStake < this._stake;
    this._stake = newStake;
    this._slotGame.getGameEventsEmitter().totalBetChanged(this._stake / 100);

    let sc = resourceManager.getController("stakeController");
    if (
      sc.isMaxStake() &&
      !this._inReplayMode &&
      !this._inRewatchMode &&
      !this._isPrePaidGame &&
      !isStakeLower
    ) {
      this._slotGame.uiComponents().clickActionHandler();
    }
  }
};

GatiServerGame.prototype.setBPL = function (bpl) {
  let baseStake = this._numLines * bpl;
  let newStake = baseStake;
  if (gameData.encoreEnabled) {
    newStake *= 1.5;
  }

  this.updateCurrentStake(newStake);
};

GatiServerGame.prototype.restorePreviousWagersDerived = function () {
  let res = this.restorePreviousWagersBase();

  if (
    this._previousWagers &&
    this._previousWagers.data &&
    this._previousWagers.data.length > 0 &&
    this._previousWagers.data[0].bets &&
    this._previousWagers.data[0].bets.length > 0 &&
    this._previousWagers.data[0].bets[0].betdata.cmd === GLOBALS.LUCKYBET_BUY
  ) {
    this.setDefaultBet(res.baseStake);
  }
  return res;
};

GatiServerGame.prototype.addGameConfigToQueueDerived = function (loadData) {
  this.addGameConfigToQueueBase(loadData);
  let message = this._messageQueue[0];
  let configMessage = this._messageQueue[this._messageQueue.length - 1];

  gameData.license = loadData.customParameters.license;
  this.cheatPanelActive = loadData.customParameters.cheatPanel === "yes";

  configMessage.maxExposure = loadData.settings.slotConfig.MaxExposure;
  message.buyBonusCostFreeSpins = this.freeSpinsCostMultiplier;

  gdk.addConfigValue(
    "AllowBuyBonus",
    message.slotConfig.gameModes[GLOBALS.BONUS_BUY] ? true : false,
  );

  message.slotConfig.coins = 10; // purely paytable

  gameData.recoveryStake = undefined;
  if (loadData.wagers.data.length) {
    let betData = loadData.wagers.data[0].bets[0].betdata;
    let stake = Number(betData.coin * 1000);
    gameData.recoveryStake = stake;
    if (betData.cmd === GLOBALS.LUCKYBET_BUY) {
      gameData.recoveryStake *= 1.5;
    }
  }

  this._rtp = message.slotConfig.rtp;

  let stopDistances2and5 = [17, 23, 29, 35, 41];
  let stopDistances3 = [30, 36, 42, 48, 54];
  let stopDistances5 = [49, 61, 73, 85, 97];
  switch (this._license) {
    case "uk":
      message.stopDistances = stopDistances2and5;
      break;
    case "UKGCRtsTest":
      message.stopDistances = stopDistances2and5;
      break;
    case "bgc":
      message.stopDistances = stopDistances2and5;
      break;
    case "es":
      message.stopDistances = stopDistances3;
      break;
    case "se":
      message.stopDistances = stopDistances3;
      break;
    case "dk":
      message.stopDistances = stopDistances3;
      break;
    case "cz":
      message.stopDistances = stopDistances2and5;
      break;
    case "co":
      message.stopDistances = stopDistances3;
      break;
    case "agcc":
      message.stopDistances = stopDistances2and5;
      break;
    case "de":
      message.stopDistances = stopDistances5;
      break;
    default:
      message.stopDistances = stopDistances3;
      break;
  }

  gameData.jackpotValues =
    loadData.settings.slotConfig.Config[
      "spinner:GameConfigEvent"
    ].initialPlayerState;
};

GatiServer.prototype.getCheatString = function () {
  return this.force;
};

GatiServer.prototype.logCheatString = function () {
  this.force =
    this._latestEngineReponse.wager.bets[0].eventdata.response.clientData.Repro;

  if (this.force !== "") {
    console.log("force: " + this.force);
  }
};

GatiServer.prototype.addCheatToRequest = function (request, forces) {
  if (!forces || forces.length === 0) return;

  if (forces.includes("[") || Array.isArray(forces)) {
    let forcesArr = forces;
    if (!Array.isArray(forces)) {
      forcesArr = JSON.parse(forces);
    }

    if (Array.isArray(forcesArr)) {
      if (forcesArr.length > 1) {
        for (let i = 1; i < forcesArr.length; i++) {
          let foundForceGamble = false;
          if (forcesArr[i] !== undefined) {
            const currentForce = forcesArr[i];

            if (currentForce[currentForce.length - 1] === "=") {
              foundForceGamble = true;
              this.gambleForces.push(forcesArr[i]);
            } else {
              // this.gambleForces = [];
            }
          } else {
            // this.gambleForces = [];
          }

          if (
            !foundForceGamble &&
            (this.gambleForces.length > 0 || forcesArr.length === 2)
          ) {
            // do we have the collect
            if (forcesArr[i] !== undefined) {
              // we have a force for the collect ASSUMING!!!
              this.collectForce = forcesArr[i];
            } else {
              this.collectForce = undefined;
            }
          }
        }
        request.cheat = forcesArr[0];
      } else {
        request.cheat = forcesArr[0];
      }
    } else {
      request.cheat = forces;
      console.log("!!! force doesn't look right... !!!");
    }
  } else {
    request.cheat = forces;
  }
};

GatiServer.prototype.updateForces = function (forces) {
  if (!forces) return undefined;
  let forcesJson = forces;

  if (!forcesJson || forcesJson.length === 0) return;

  return forcesJson;
};

GatiServerGame.prototype.handleSkipWin = function (engineResponse) {
  if (engineResponse.wager.bets[0].betdata.cmd === "LUCKYBET_BUY") {
    game.enableEncore(true, true);
  }
};

GatiServerGame.prototype.addRecoveryToQueueDerived = function () {
  for (let i = 0; i < this._latestEngineReponse.wager.bets.length; ++i) {
    let bet = this._latestEngineReponse.wager.bets[i];
    if (bet.betdata.cmd === GLOBALS.LUCKYBET_BUY) {
      this._inEncore = true;
      this._meta = {
        name: "encore",
        value: true,
      };
      break;
    } else if (bet.betdata.cmd === GLOBALS.BONUS_BUY) {
      this._inBuyABonus = true;
      this._meta = {
        name: "buyABonus",
        value: true,
      };
      break;
    }
  }
  this.addRecoveryToQueueBase();
};

GatiServerGame.prototype.startGameDerived = function (stakeData, cb) {
  this._finalBaseWinnings = 0;
  this._totalWinnings = 0;
  this._inEncore = stakeData.metaData.encore;
  this._inBuyABonus = stakeData.metaData.buyABonus;

  this.gambleForces = [];
  this.collectForce = undefined;

  if (this._forces === undefined || !this._forces) {
    this._forces = "";
    this.addCheatToRequest(stakeData, this._forces);
  }

  this.startGameBase(stakeData, cb);
};

GatiServerGame.prototype.addMetaDataToSpinRequest = function (request) {
  // "BASIC": 10, "BONUS_BUY": 1000, "LUCKYBET_BUY": 15
  this._coinValue = 10;
  let stakeController = resourceManager.getController("stakeController");
  let baseStake = stakeController.getBaseStake("default") / 100;

  if (this._forces === "" && this.cheatPanelActive) {
    request.cheat = JSON.stringify(null);
  }

  request.coin = request.amount / this._coinValue;
  request.coins = this._coinValue;

  if (this._inEncore) {
    request.coins = 15;
    request.amount = baseStake * 1.5;
    request.coin = baseStake / this._coinValue; // should be 0.1 on a base stake of £1, so £1.50 for lucky bet
    request.cmd = GLOBALS.LUCKYBET_BUY;
  } else if (this._inBuyABonus) {
    baseStake = stakeController.getBaseStake(GLOBALS.BONUS_BUY) / 100;
    request.amount = baseStake * this.freeSpinsCostMultiplier;
    request.coins = 1000;
    request.coin = baseStake / this._coinValue;
    request.cmd = GLOBALS.BONUS_BUY;
  }
};

GatiServerGame.prototype.getSpinDataNormal = function (data, stake) {
  const spinEvent = data;
  const spinData = data.respins;

  if (!this.validateResponse(spinEvent)) return;
  this.addSpinDataToQueue(spinEvent, stake);

  const isCapped = data.isCapped;
  const length = isCapped ? spinData.length : spinData.length - 1;
  const totalWinInBase = data.winAmount;
  this._baseGameWinnings += data.winAmount;

  let potsOfGoldAdded = false;
  for (let i = 0; i < length; ++i) {
    const isNotFinal = spinData[i + 1];

    const winningLineEvent = spinData[i];

    if (isNotFinal) {
      const poppedSymbols = spinData[i].winningCoords;

      spinData[i].wildCoords.forEach((wildCoord) => {
        const lowestRow = wildCoord.row;
        const wildReel = wildCoord.reel;

        poppedSymbols.forEach((symbol) => {
          if (symbol.reel === wildReel && symbol.row === lowestRow + 1) {
            lowestRow = symbol.row;
            wildCoord.row = symbol.row;
          }
        });
      });

      this.addPopsToQueue(
        null,
        winningLineEvent,
        spinData[i].winAmount,
        spinData[i].winAmountBeforeMultiplier,
        spinData[i].multiplier,
        spinData[i + 1].multiplier,
        isCapped,
        false,
      );
      this.addDropsToQueue(
        spinData[i + 1].spinEvent.resultsPanel.reelList,
        spinData[i + 1].wildCoords,
        poppedSymbols,
        this.getCashPotData(spinData[i + 1].pots, stake),
      );
    } else {
      this.addPopsToQueue(
        data.potsOfGoldAwards,
        winningLineEvent,
        spinData[i].winAmount,
        spinData[i].winAmountBeforeMultiplier,
        1,
        1,
        isCapped,
        true,
        true,
      );
      potsOfGoldAdded = true;
    }
  }

  if (!potsOfGoldAdded && data.potsOfGoldAwards.potsWon.length > 0) {
    this.addPopsToQueue(
      data.potsOfGoldAwards,
      data.respins[data.respins.length - 1],
      data.potsOfGoldAwards.totalWinAmount,
      data.potsOfGoldAwards.totalWinAmount,
      1,
      1,
      isCapped,
      true,
      true,
    );
  }
  this.addPopDropsOverToQueue(totalWinInBase, isCapped);

  return totalWinInBase;
};

GatiServer.prototype.getCashPotData = function (pots, stake) {
  const cashPotData = [];
  pots.forEach((pot) => {
    cashPotData.push({
      reel: pot.coord.reel,
      row: pot.coord.row,
      type: pot.type,
      value: (pot.value * stake) / 100,
      name: pot.potName,
    });
  });
  return cashPotData;
};

GatiServer.prototype.addSpinDataToQueue = function (event, stake) {
  var message = {};
  message.type = "spinner:SpinEvent";
  message.panelMultiplier = 1;
  // event.lines;
  message.isPrePaidGame = this._isPrePaidGame;
  message.baseBet = this._stake;
  message.betMultiplier = 1;
  message.totalWinnings = event.winAmount;
  message.resultPanel = {};
  message.resultPanel.reels = GLOBALS.NUMBER_OF_REELS;
  message.resultPanel.rectangular = true;

  if (event.jackpotGame !== undefined && event.jackpotGame === true) {
    message.jackpotGame = true;
  }

  message.resultPanel.reelList =
    event.respins[0].spinEvent.resultsPanel.reelList;
  message.resultPanel.symbolsAbove = undefined;
  message.resultPanel.symbolsBelow = undefined;
  message.cashPotData = this.getCashPotData(event.respins[0].pots, stake);

  // if modifier is awarded
  // then we drop_initial_symbols as the reelset & cash pots from modifier
  // and then drop first cascade symbols as respins[0]

  if (event.modifier?.isAwarded) {
    message.resultPanel.reelList = event.modifier.resultsPanel.reelList;
    message.cashPotData = this.getCashPotData(event.modifier.pots, stake);
  }

  if (this._localRngSeed !== -1) {
    message.localRng = this._localRngSeed;
  }

  this._messageQueue.push(message);

  if (event.modifier?.isAwarded) {
    this.addModifierEventToQueue(
      event.modifier.eliminations,
      event.respins[0].spinEvent.resultsPanel.reelList,
      this.getCashPotData(event.respins[0].pots, stake),
    );
  }
};

GatiServerGame.prototype.getSpinDataFS = function (cb, stake) {
  const data = this.freeSpins[this.fsCount++];
  const spinEvent = data;
  --this.numFsRemaining;

  this.addSpinDataToQueue(spinEvent, stake);

  this.freeSpinsWinnings += spinEvent.winAmount;
  const isCapped =
    this.freeSpinsCapped && this.freeSpinsWinnings >= this._finalFsWinnings; // this.freeSpinsCapped;
  const length = isCapped ? data.respins.length : data.respins.length - 1;
  const spinWin = data.winAmount;

  let isNotFinal = true;
  let potsOfGoldAdded = false;
  for (let i = 0; i < length; ++i) {
    //If no win on first drop in, the cascade data array will not be longer then 1
    isNotFinal = data.respins[i + 1];

    const winningLineEvent = data.respins[i];

    if (isNotFinal) {
      const poppedSymbols = data.respins[i].winningCoords;

      data.respins[i].wildCoords.forEach((wildCoord) => {
        const lowestRow = wildCoord.row;
        const wildReel = wildCoord.reel;

        poppedSymbols.forEach((symbol) => {
          if (symbol.reel === wildReel && symbol.row === lowestRow + 1) {
            lowestRow = symbol.row;
            wildCoord.row = symbol.row;
          }
        });
      });

      this.addPopsToQueue(
        null,
        winningLineEvent,
        data.respins[i].winAmount,
        data.respins[i].winAmountBeforeMultiplier,
        data.respins[i].multiplier,
        data.respins[i + 1].multiplier,
        isCapped,
        false,
      );
      this.addDropsToQueue(
        data.respins[i + 1].spinEvent.resultsPanel.reelList,
        data.respins[i + 1].wildCoords,
        poppedSymbols,
        this.getCashPotData(data.respins[i + 1].pots, stake),
      );
    } else {
      this.addPopsToQueue(
        data.potsOfGoldAwards,
        winningLineEvent,
        data.respins[i].winAmount,
        data.respins[i].winAmountBeforeMultiplier,
        1,
        1,
        isCapped,
        true,
        true,
      );
      potsOfGoldAdded = true;
    }
  }

  if (!potsOfGoldAdded && data.potsOfGoldAwards.potsWon.length > 0) {
    this.addPopsToQueue(
      data.potsOfGoldAwards,
      data.respins[data.respins.length - 1],
      data.potsOfGoldAwards.totalWinAmount,
      data.potsOfGoldAwards.totalWinAmount,
      1,
      1,
      isCapped,
      true,
      true,
    );
  }

  this.fsWinnings += spinWin;
  this.addPopDropsOverToQueue(spinWin, isCapped);

  if (this.fsCount < this.freeSpins.length) {
    this.addFSDataToQueue();
  } else {
    this.addFSEndToQueue(this.freeSpinsCapped);
    this.addGameCompleteToQueue(this.fsWinnings);
    this.inFS = false;
    this.numFsRemaining = 0;
  }

  cb();

  this.triggerNextMessage();
};

GatiServerGame.prototype.sendGambleResponseToServer = function (
  numScatters,
  response,
  cb,
) {
  if (this._gameNotFullyRecovered) {
    // no need to send state, already done and part of recovery
    this.moveToNextBetData();
    messageBus.postImmediate("Gamble:HandledCommand");
    timerManager.addTimer(500, undefined, cb);
    return;
  }

  this.resetCurrentBetData();

  let self = this;
  let nextStep =
    self._latestEngineReponse.wager.bets[
      self._latestEngineReponse.wager.bets.length - 1
    ].step + 1;
  let commands =
    self._latestEngineReponse.wager.bets[
      self._latestEngineReponse.wager.bets.length - 1
    ].betdata.cmds;
  let command;

  if (response === "gamble") {
    command = commands[1];
  } else {
    command = commands[0];
  }

  let playData = {
    cmd: command,
    step: nextStep,
    clientParams: "",
  };

  if (this.gambleForces.length > 0) {
    playData.cheat = this.gambleForces.shift();
  } else if (this.collectForce !== undefined) {
    playData.cheat = this.collectForce;
    this.collectForce = undefined;
  } else if (this.cheatPanelActive) {
    playData.cheat = JSON.stringify(null);
  }

  // if (this._forces) {
  //   this.addCheatToRequest(playData, this._forces);
  // }

  const sendCommand = async () => {
    self._latestEngineReponse = await self._slotGame.play(playData);
    self._forces = self.updateForces(self._forces);
    cb();
  };

  sendCommand();
};

GatiServerGame.prototype.addFSAwardToQueue = function (data) {
  const currentScatterCount = data.scatterCount;
  const nextScatterCount = currentScatterCount + 1;

  data.spinsCount =
    GLOBALS.NUMBER_OF_SCATTERS_TO_FREE_SPINS[currentScatterCount];

  const message = {};
  message.type = "game:FreeSpinsAwardEvent";
  message.freeSpinsAwarded =
    GLOBALS.NUMBER_OF_SCATTERS_TO_FREE_SPINS[currentScatterCount];
  message.possibleValues = Object.values(
    GLOBALS.NUMBER_OF_SCATTERS_TO_FREE_SPINS,
  );
  message.numScatters = data.scatterCount;
  message.nextFreespins =
    GLOBALS.NUMBER_OF_SCATTERS_TO_FREE_SPINS[nextScatterCount];
  message.x3WinChance =
    (data.x3WinChance ?? 0) / (data.x3WinChanceDenominator ?? 1);
  message.x4WinChance =
    (data.x4WinChance ?? 0) / (data.x4WinChanceDenominator ?? 1);
  message.buyABonus = this._inBuyABonus;
  message.numFreeSpins =
    GLOBALS.NUMBER_OF_SCATTERS_TO_FREE_SPINS[currentScatterCount];
  let self = this;
  message.resultCallback = function (obj, cb) {
    self.sendGambleResponseToServer(data.scatterCount, obj.response, cb);
  };

  this._messageQueue.push(message);
};

GatiServerGame.prototype.addGambleResultToQueue = function (won) {
  var message = {};
  message.type = "fire_gems:GambleResultEvent";
  message.won = won;
  if (this._localRngSeed !== -1) {
    message.localRng = this._localRngSeed;
  }
  this._messageQueue.push(message);
};

GatiServer.prototype.requestNextSpinOutcome = function (cb) {
  this.logCheatString();
  const outcome =
    this._latestEngineReponse.wager.bets[this._currentBetData].eventdata
      .response.clientData;
  const playerState =
    this._latestEngineReponse.wager.bets[this._currentBetData].eventdata
      .playerState.state;
  const initialPlayerState = outcome.InitialGameState;
  this.getSpinData(
    cb,
    outcome,
    JSON.parse(playerState ?? "null"),
    initialPlayerState,
  );
};

GatiServerGame.prototype.getSpinData = function (
  cb,
  data,
  playerState,
  initialPlayerState,
) {
  const stake = data.BasicStake;

  if (this.inFS) {
    this.getSpinDataFS(cb, stake);
    return;
  }

  this._forces = "";

  let parts = data.Parts;

  let totalWon = 0;
  this._localRngSeed = -1;

  for (let i = 0; i < parts.length; ++i) {
    let type = parts[i].type;
    if (type === "baseGame") {
      this._finalBaseWinnings = parts[0].winAmount;
      totalWon += this.getSpinDataNormal(parts[i], stake);
      this._localRngSeed = data.ResultId;

      // base game only, game complete
      if (parts.length === 1) {
        this.addGameCompleteToQueue(totalWon);
      }
    } else if (type === "gambleEntered") {
      this.addFSAwardToQueue(parts[i]);
      this.inGamble = true;
    } else if (type === "gambleResult") {
      this._localRngSeed = data.ResultId;
      let won = parts[i].hasWon;
      this.addGambleResultToQueue(won);
      if (!won) {
        this.inGamble = false;
        this.addGameCompleteToQueue(totalWon);
      }
    } else if (type === "freeSpins") {
      this.inGamble = false;
      this.inFS = true;
      this.freeSpinsWinnings = 0;
      this.fsCount = 0;
      this.freeSpins = parts[i].spins;
      this.freeSpinsCapped = parts[i].isCapped;
      this._finalFsWinnings = data.Parts[0].winAmount;
      this._totalWinnings = this._finalBaseWinnings + this._finalFsWinnings;
      this.addFSStartToQueue(
        GLOBALS.NUMBER_OF_SCATTERS_TO_FREE_SPINS[parts[i].scatterCount],
        parts[i].potsDoubledOnEntry,
      );
    }
  }

  cb();
  this.triggerNextMessage();
};

GatiServerGame.prototype.addPopsToQueue = function (
  potsAwarded,
  winningsLinesMessage,
  winAmount,
  winAmountBeforeMultiplier,
  multiplier,
  nextMultiplier,
  isCapped,
  isFinalCapped,
  isFinal = false,
) {
  const message = winningsLinesMessage;
  message.type = "spinner:WinningLinesEvent";
  message.totalLineWinnings = winAmount;
  message.multiplier = multiplier;
  message.nextMultiplier = nextMultiplier;
  message.preMultiplier = winAmountBeforeMultiplier;
  message.potsAwarded = potsAwarded;
  message.isCapped = isCapped && isFinalCapped;

  const winningLines = winningsLinesMessage.winningLineEvent.winningLines;
  if (isFinal && potsAwarded != null && potsAwarded.potsWon.length > 0) {
    const potPositions = potsAwarded.potsWon.map((pot) => {
      return { reel: pot.coord.reel, row: pot.coord.row };
    });
    const wildBridgePositions = potsAwarded.wildUsedInPotWin
      ? potsAwarded.wildsUsedInPotWinCoords
      : [];
    const potsWonData = {
      winAmount: potsAwarded.totalWinAmount,
      occurrences: potsAwarded.potsWon.length,
      positions: potPositions.concat(wildBridgePositions),
      symbol: {
        value: GLOBALS.POT_SYMBOL_ID,
        ids: new Array(potsAwarded.potsWon.length).fill(GLOBALS.POT_SYMBOL_ID),
      },
    };
    winningLines.push(potsWonData);
  }

  for (let i = 0; i < winningLines.length; ++i) {
    const winData = winningLines[i];

    // this winning symbol id
    const winSymbolId = winData.symbol.value;

    // an array of all winning symbols in this win (including wilds)
    winData.winSymPositions = [];

    // loop through all reels
    for (let reel = 0; reel < GLOBALS.NUMBER_OF_REELS; reel++) {
      // symbols on this reel
      const reelList =
        winningsLinesMessage.spinEvent.resultsPanel.reelList[reel];

      // loop through all currently active symbols on this reel
      for (let row = 0; row < 3; row++) {
        // symbol on reel
        const symID = reelList.symbols[row].value;

        for (let i = 0; i < winData.positions.length; i++) {
          if (
            winData.positions[i].reel === reel &&
            winData.positions[i].row === row
          ) {
            //check it's a winning symbol
            // is it symbol we are looking for or a wild
            if (
              symID === winSymbolId ||
              symID === GLOBALS.WILD_SYMBOL_ID ||
              symID === GLOBALS.POT_SYMBOL_ID
            ) {
              winData.winSymPositions.push({
                reel: reel,
                row: row,
                sym: symID,
              });
            }
          }
        }
      }
    }
  }
  // loop through all winning symbols

  this._messageQueue.push(message);
  //message.winningSymbols = winningSymbols;

  //this.gameOutcome.outcomeWinnings;
  //message.totalLineWinningsNonMultiplied = unMultiplied;

  //this._messageQueue.push(message);
};

GatiServerGame.prototype.addDropsToQueue = function (
  serverWindow,
  wildCells,
  poppedSymbols,
  cashPotData,
) {
  const popWindow = [
    [0, 0, 0],
    [0, 0, 0],
    [0, 0, 0],
    [0, 0, 0],
    [0, 0, 0],
  ];

  poppedSymbols.forEach(({ reel, offset }) => {
    popWindow[reel][offset] = -1;
  });

  wildCells.forEach(({ reel, offset }) => {
    popWindow[reel][offset] = 0;
  });

  const newWindow = [];
  for (let i = 0; i < serverWindow.length; ++i) {
    let slot = [];
    let serverSlot = serverWindow[i].symbols;
    for (j = 0; j < serverSlot.length; ++j) {
      slot.push({ _id: serverSlot[j].value });
    }

    newWindow.push(slot);
  }

  const message = {
    type: "game:DropEvent",
    tumbleData: popWindow,
    window: newWindow,
    cells: wildCells,
    extraWild: null,
    cashPotData: cashPotData,
  };

  this._messageQueue.push(message);
};

GatiServerGame.prototype.addModifierEventToQueue = function (
  eliminatedSymbols,
  reelList,
  cashPots,
) {
  const message = {};
  message.type = "game:ModifierEvent";
  message.eliminatedSymbols = eliminatedSymbols;

  const poppedSymbols = [];
  eliminatedSymbols.forEach((eliminatedSymbol) => {
    poppedSymbols.push({
      reel: eliminatedSymbol.reel,
      row: eliminatedSymbol.row,
      offset: eliminatedSymbol.row,
      newSyms: eliminatedSymbol.symbolToCascadeIn,
      reelToHide: eliminatedSymbol.reel,
    });
  });

  this._messageQueue.push(message);
  this.addDropsToQueue(reelList, [], poppedSymbols, cashPots);
};

GatiServerGame.prototype.addPopDropsOverToQueue = function (
  winnings,
  isCapped,
) {
  var message = {};
  message.type = "game:PopAndDropComplete";
  message.winnings = winnings;
  message.isCapped = isCapped;
  message.totalWinnings = this._finalBaseWinnings;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addFSStartToQueue = function (
  numFs,
  buyABonusDoubledPots,
) {
  this.fsWinnings = 0;
  var message = {};
  message.type = "game:FreeSpinsStartEvent";
  message.freeSpinsAwarded = numFs;
  this.numFsRemaining = numFs;

  // if (isCapped) {
  //   message.freeSpinsAwarded = 13;
  // }

  message.bonuswin = 0;
  message.currentMultiplier = 1;
  message.nextMultiplier = 2;
  message.buyABonusDoubledPots = buyABonusDoubledPots;
  this.inGamble = false;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addFSDataToQueue = function () {
  var message = {};
  message.type = "game:FreeSpinsDataEvent";
  message.num = this.numFsRemaining;
  message.fsWinnings = this.fsWinnings;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addFSEndToQueue = function (isCapped) {
  var message = {};
  message.type = "game:FreeSpinsEndEvent";
  message.fsWinnings = this.fsWinnings;
  message.finalFsWinnings = this._finalFsWinnings;
  message.totalWinnings = this._totalWinnings;
  message.isCapped = isCapped;
  this.fsWinnings = 0;
  this.inFS = false;
  this._messageQueue.push(message);
};

GatiServer.prototype.addGameCompleteToQueue = function (totalWon) {
  var message = {
    type: "common:GameCompleteEvent",
    totalWinnings: totalWon,
  };
  this._messageQueue.push(message);
};
